// Dependency-free note identifiers, safe to import from client components without pulling in the
// workflow/repo/EHR modules that define the note producers.

export const REFERRAL_UPLOAD_NOTE_ID = "document_upload";
export const REFERRAL_INELIGIBLE_NOTE_ID = "ineligible";
export const CARE_PLAN_FAX_NOTE_ID = "care_plan_fax";
